import LearnPageLayout from "@/components/LearnPageLayout";
import { saintFlorida } from "./learnDataSaintFlorida";

/**
 * Static route wrapper for /saint-tms-florida.
 */
const SaintFloridaPage = () => (
  <LearnPageLayout
    title={saintFlorida.title}
    description={saintFlorida.description}
    canonical={saintFlorida.canonical}
    h1={saintFlorida.h1}
    breadcrumbLabel={saintFlorida.breadcrumbLabel}
    crumbs={saintFlorida.crumbs}
    shortAnswer={saintFlorida.shortAnswer}
    keyTakeaways={saintFlorida.keyTakeaways}
    sections={saintFlorida.sections}
    faqs={saintFlorida.faqs}
    sources={saintFlorida.sources}
    schemaJson={saintFlorida.schemaJson}
    relatedLinks={saintFlorida.relatedLinks}
    reviewBlock={saintFlorida.reviewBlock}
  />
);

export default SaintFloridaPage;
